import React, { useContext } from 'react';
import clsx from 'clsx';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
  btnAccordion,
  reverse,
  accordionArrow,
  accordionArrowActive,
  accordionArrowLeft,
  accordionArrowLeftActive
} from '@styles/modules/common.module.scss';

const ContextAwareToggle = ({
  children,
  eventKey,
  callback,
  arrow,
  black }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <button
      type="button"
      className={clsx(`position-relative ps-4 no-hover text-decoration-none text-start`, btnAccordion, { [reverse]: arrow === 'left' })}
      onClick={decoratedOnClick}
    >
      {children}
      <FontAwesomeIcon
        className={clsx('me-2', accordionArrow, {
          [accordionArrowActive]: isCurrentEventKey && arrow !== 'left',
          [accordionArrowLeft]: arrow === 'left',
          [accordionArrowLeftActive]: isCurrentEventKey && arrow === 'left',
          'text-black':black
        })}
        icon={faChevronDown}
        size='xs'
      />
    </button>
  )
}

export default ContextAwareToggle
